export default "__VITE_ASSET__D$lS0ADe__"